<template>
  <nav class="c-nav bg-white h-full fixed">
    <div class="c-nav__menu h-screen flex flex-col justify-between mt-32">
      <ul>
        <li class="c-nav__menuitem" v-for="item in menuListItem" :key="item.id">
          <router-link
            :to="item.url"
            :class="{ active: item.isActive }"
            class="flex py-4 px-4 my-4 text-gray-1 hover:border-l-3 hover:border-solid hover:border-primary-normal hover:bg-primary-light hover:text-primary-normal"
          >
            <svg
              v-if="item.id == 0"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              height="22"
              width="22"
            >
              <path
                opacity="0.5"
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.24963 1.37544H1.37444V8.25062H8.24963V1.37544ZM8.24963 9.62506H1.37444C0.615301 9.62506 0 9.00976 0 8.25062V1.37544C0 0.6163 0.615301 0 1.37444 0H8.24963C9.00876 0 9.62506 0.6163 9.62506 1.37544V8.25062C9.62506 9.00976 9.00876 9.62506 8.24963 9.62506ZM8.24963 13.7504H1.37444V20.6256H8.24963V13.7504ZM8.24963 22H1.37444C0.615301 22 0 21.3847 0 20.6256V13.7504C0 12.9902 0.615301 12.3749 1.37444 12.3749H8.24963C9.00876 12.3749 9.62506 12.9902 9.62506 13.7504V20.6256C9.62506 21.3847 9.00876 22 8.24963 22ZM20.6246 1.37544H13.7494V8.25062H20.6246V1.37544ZM20.6246 9.62506H13.7494C12.9902 9.62506 12.3749 9.00976 12.3749 8.25062V1.37544C12.3749 0.6163 12.9902 0 13.7494 0H20.6246C21.3837 0 22 0.6163 22 1.37544V8.25062C22 9.00976 21.3837 9.62506 20.6246 9.62506ZM20.6246 13.7504H13.7494V20.6256H20.6246V13.7504ZM20.6246 22H13.7494C12.9902 22 12.3749 21.3847 12.3749 20.6256V13.7504C12.3749 12.9902 12.9902 12.3749 13.7494 12.3749H20.6246C21.3837 12.3749 22 12.9902 22 13.7504V20.6256C22 21.3847 21.3837 22 20.6246 22Z"
                fill="#013C61"
              />
            </svg>
            <svg
              fill="none"
              v-else-if="item.id == 1"
              viewBox="0 0 24 24"
              stroke="currentColor"
              class="users w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              ></path>
            </svg>
            <svg
              v-else
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              class="credit-card w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
              ></path>
            </svg>
            <!-- <span class="ml-3">{{ item.title }}</span> -->
          </router-link>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Nav",
  props: {
    mode: String,
    menuListItem: Array,
    user: Object
  },
  data() {
    return {
      isClosed: false
    };
  }
};
</script>

<style lang="postcss">
.c-nav {
  width: 60px;
  position: fixed;
  left: 0;
  z-index: 49;
  top: 0;
  transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.c-nav__header {
  top: 18px;
  left: 10px;
}

.c-nav__user {
  height: 100px;
  padding: 30px;
}

.c-nav__menuitem a {
  width: 100%;
  transition: border 0.1s linear, width 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    background-color 0.25s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
.c-nav__menuitem a svg {
  width: 24px;
  height: 24px;
}

.c-nav .c-nav__menuitem a span {
  transition: visibility 0.1s 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Actve state */
.c-nav__menuitem a.router-link-exact-active {
  @apply border-l-4 border-solid border-primary;
}

.c-nav__menuitem a.router-link-exact-active svg {
  stroke: #2bda53;
}
</style>
